// import getApolloClient from './apolloClient'
// import gql from 'graphql-tag'
// import Vue from 'vue'
import request from './request'


const way = './graphql/additional fields/',
  mutation_way =  way + 'mutations/',
  query_way =  way + 'query/',
  environment = '/additionalFields'

export default class AdditionalFieldsApi {

  async getAdditionalFieldStatistic( model) {
    return await request({
      environment,
      type: 'query',
      name: 'getAdditionalFieldStatistic',
      variables: { model },
      way: query_way,
      has_catch: true
    })
  }
  async getAdditionalFields(model) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAdditionalFields',
      variables: { model },
      way: query_way,
      has_catch: true
    })
  }

  async getAdditionalField( fieldId) {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAdditionalField',
      variables: { fieldId },
      way: query_way,
      has_catch: true
    })
  }

  async getAdditionalFieldsByBindingConditions(model) {
    const result = await request({
      environment,
      type: 'query' ,
      name: 'getAdditionalFieldsByBindingConditions',
      variables: { model },
      way: query_way,
      has_catch: true
    })

    let order = 1
    result?.forEach((item) => {
      if (item.order) {
        order = item.order
      } else {
        item.order = order
      }
      order++
    })

    return result
  }

  async getAdditionalFieldsByEntity(model) {
    const result = await request({
      environment,
      type: 'query' ,
      name: 'getAdditionalFieldsByEntity',
      variables: { model },
      way: query_way,
      has_catch: true
    })

    let order = 1
    result?.forEach((item) => {
      if (item.order) {
        order = item.order
      } else {
        item.order = order
      }
      order++
    })

    return result
  }

  async getAdditionalFieldTypes() {
    return await request({
      environment,
      type: 'query' ,
      name: 'getAdditionalFieldTypes',
      way: query_way,
      has_catch: true
    })
  }

  // mutations //////////////////////////////////////////////////////////////////////


  async bindAdditionaFiledToEntity( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'bindAdditionaFiledToEntity',
      variables: {
        model
      },
      way: mutation_way,
      has_catch: true
    })
  }

  async createAdditionaFiledType( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'createAdditionaFiledType',
      variables: {
        model
      },
      way: mutation_way,
      has_catch: true
    })
  }

  async createAdditionalField( model) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'createAdditionalField',
      variables: {
        model
      },
      way: mutation_way,
      has_catch: true
    })
  }

  async updateAdditionalField(model) {
    delete model.formData
    delete model.type
    delete model.__typename
    delete model.value
    model.settingValues?.forEach(set => {
      delete set.__typename
      set.value = set.value.toString()
    })

    delete model.bindingCondition.__typename
    model.bindingCondition?.biddingTypeIds?.forEach(set => {
      delete set.__typename
    })
    model.bindingCondition?.classificationCodes?.forEach(set => {
      delete set.__typename
      delete set.category
    })

    const convertModel = {
      bindingLevel: model.bindingLevel,
      active: model.active,
      caption: model.caption,
      showForBidders: model.showForBidders,
      showAsSpecialField: model.showAsSpecialField,
      defaultValue: model.defaultValue,
      id: model.id,
      typeId: model.typeId,
      bindingCondition: model.bindingCondition,
      settingValues: model.settingValues,
      fieldTranslations: model.fieldTranslations
    }

    return await request({
      environment,
      type: 'mutation',
      name: 'updateAdditionalField',
      variables: {
        model: convertModel
      },
      way: mutation_way,
      has_catch: true
    })
  }

  async deleteAdditionaFiled( fieldId ) {
    return await request( {
      environment,
      type: 'mutation',
      name: 'deleteAdditionaFiled',
      variables: {
        fieldId
      },
      way: mutation_way,
      has_catch: true,
      catch_callback: error => {
        throw error
      }
    })
  }


}
